import { isFunction, isJsObject } from "./utils";


export function getClientRect(elem: any): DOMRect | null {
  return isJsObject(elem) && isFunction(elem.getBoundingClientRect) ?
    elem.getBoundingClientRect() : null;
}
